import React from 'react'
import {
  TransportScoreCardProps,
  ScoreHeaderProps,
  ScoreTitleProps,
  ScoreValueProps,
  ScoreLabelProps,
} from './TransportScoreCard.types'
import {
  ScoreCard as StyledScoreCard,
  ScoreHeader as StyledScoreHeader,
  ScoreTitle as StyledScoreTitle,
  ScoreValue as StyledScoreValue,
  ScoreLabel as StyledScoreLabel,
} from './TransportScoreCard.styles'

export const TransportScoreCard: React.FC<TransportScoreCardProps> = ({
  variant,
  children,
  className,
  style,
}) => {
  return (
    <StyledScoreCard $variant={variant} className={className} style={style}>
      {children}
    </StyledScoreCard>
  )
}

export const ScoreHeader: React.FC<ScoreHeaderProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledScoreHeader className={className} style={style}>
      {children}
    </StyledScoreHeader>
  )
}

export const ScoreTitle: React.FC<ScoreTitleProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledScoreTitle className={className} style={style}>
      {children}
    </StyledScoreTitle>
  )
}

export const ScoreValue: React.FC<ScoreValueProps> = ({
  size,
  children,
  className,
  style,
}) => {
  return (
    <StyledScoreValue $size={size} className={className} style={style}>
      {children}
    </StyledScoreValue>
  )
}

export const ScoreLabel: React.FC<ScoreLabelProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledScoreLabel className={className} style={style}>
      {children}
    </StyledScoreLabel>
  )
}

TransportScoreCard.displayName = 'TransportScoreCard'
ScoreHeader.displayName = 'ScoreHeader'
ScoreTitle.displayName = 'ScoreTitle'
ScoreValue.displayName = 'ScoreValue'
ScoreLabel.displayName = 'ScoreLabel'
